export const settingConstants = {

    GET_SETTING_ORDER_REQUEST: 'GET_SETTING_ORDER_REQUEST',
    GET_SETTING_ORDER_SUCCESS: 'GET_SETTING_ORDER_SUCCESS',
    GET_SETTING_ORDER_FAILURE: 'GET_SETTING_ORDER_FAILURE',


    EDIT_SETTING_ORDER_REQUEST: 'EDIT_SETTING_ORDER_REQUEST',
    EDIT_SETTING_ORDER_SUCCESS: 'EDIT_SETTING_ORDER_SUCCESS',
    EDIT_SETTING_ORDER_FAILURE: 'EDIT_SETTING_ORDER_FAILURE',

    GET_SHARE_LINK_SETTING_REQUEST: 'GET_SHARE_LINK_SETTING_REQUEST',
    GET_SHARE_LINK_SETTING_SUCCESS: 'GET_SHARE_LINK_SETTING_SUCCESS',
    GET_SHARE_LINK_SETTING_FAILURE: 'GET_SHARE_LINK_SETTING_FAILURE',

    EDIT_SHARE_LINK_SETTING_REQUEST: 'EDIT_SHARE_LINK_SETTING_REQUEST',
    EDIT_SHARE_LINK_SETTING_SUCCESS: 'EDIT_SHARE_LINK_SETTING_SUCCESS',
    EDIT_SHARE_LINK_SETTING_FAILURE: 'EDIT_SHARE_LINK_SETTING_FAILURE',

};